import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import {
  Card, CardBody, Row, Col, Container, Badge,
} from 'reactstrap';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import renderSelectField from '../../../shared/components/form/Select';
import TextBox from '../../../shared/components/form/TextBox';
import setPropsAsInitialValues from '../../../helpers/setPropsAsInitialValues';
import validate from './moveExamInscriptionsValidate';

class MoveExamInscriptionsForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onChangeSelect: PropTypes.func.isRequired,
    onStudentEnrollmentChanges: PropTypes.func.isRequired,
    onCheckAllChanges: PropTypes.func.isRequired,
    handleFilterChangeText: PropTypes.func.isRequired,
    students: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    exams: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    exam: PropTypes.shape({}),
    error: PropTypes.string,
    checkAll: PropTypes.bool,
    filterValue: PropTypes.string,
    submitting: PropTypes.bool,
    sourceExamLabel: PropTypes.string,
  }

  static defaultProps = {
    exam: { value: 0 },
    error: '',
    checkAll: false,
    filterValue: '',
    submitting: false,
    sourceExamLabel: '',
  }

  render() {
    const {
      handleSubmit,
      onBack,
      onChangeSelect,
      onStudentEnrollmentChanges,
      onCheckAllChanges,
      handleFilterChangeText,
      students,
      exams,
      checkAll,
      filterValue,
      submitting,
      sourceExamLabel,
      error,
    } = this.props;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">Mover inscripciones de examen</h5>
              <Badge style={{ fontSize: 14 }} color="primary" pill>
                Examen origen: {sourceExamLabel}
              </Badge>
            </div>
            <Form className="form" onSubmit={handleSubmit}>
              <Container className="summary-container">
                <Row>
                  <Col md={8}>
                    <div className="form__form-group">
                      <span className="form__form-group-label required">Examen destino</span>
                      <div className="form__form-group-field">
                        <Field
                          name="exam"
                          component={renderSelectField}
                          options={exams}
                          onChange={props => onChangeSelect(props)}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md={12} xl={12} sm={12}>
                    <div
                      className="summary-card__item fs-16 form"
                      style={{
                        fontSize: 17,
                        display: 'flex',
                        fontWeight: 'bold',
                      }}
                    >
                      <span className="form__form-group-label" style={{ minWidth: '180px' }}>Filtrar alumnos:</span>
                      <div className="form__form-group-field" style={{ width: '100%' }}>
                        <Field
                          name="filterValue"
                          component={TextBox}
                          placeholder="Texto a buscar"
                          autoComplete="false"
                          type="text"
                          onChange={handleFilterChangeText}
                          maxLength={64}
                          defaultValue={filterValue}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <Field
                      name="checkAll"
                      component={renderCheckBoxField}
                      label="Seleccionar Todos"
                      value={checkAll}
                      defaultChecked={checkAll}
                      onChange={v => onCheckAllChanges(v)}
                    />
                    {error && <span className="form__form-group-error">{error}</span>}
                  </Col>
                </Row>

                <Row>
                  {students.map(s => (
                    <Col md={6} xl={4} sm={12} key={`col_student_${s.id}`}>
                      <div
                        className="summary-card__item fs-16"
                        style={{
                          fontSize: 15,
                          display: 'flex',
                          marginTop: '10px',
                        }}
                      >
                        <Field
                          key={`student_${s.id}`}
                          name={`student_${s.id}`}
                          component={renderCheckBoxField}
                          label={`${s.numeroDocumento}: ${s.alumno} (${s.anioInscripcion || 'S/A'})`}
                          className={s.selected ? 'checked' : ''}
                          value={s.selected}
                          defaultChecked={s.selected}
                          onChange={v => onStudentEnrollmentChanges(v, s)}
                        />
                      </div>
                    </Col>
                  ))}
                </Row>

                <div className="card__title">
                  <button type="submit" className="btn btn-primary" disabled={submitting}>Mover alumnos</button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={onBack}
                  >
                    Cancelar - Volver
                  </button>
                </div>
              </Container>
            </Form>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const ReduxMoveExamInscriptionsForm = reduxForm({
  form: 'MoveExamInscriptionsForm',
  validate,
  enableReinitialize: true,
})(MoveExamInscriptionsForm);

export default setPropsAsInitialValues(ReduxMoveExamInscriptionsForm);
